import { render, staticRenderFns } from "./MiniGameList.vue?vue&type=template&id=f5676c30&scoped=true"
import script from "./MiniGameList.vue?vue&type=script&lang=js"
export * from "./MiniGameList.vue?vue&type=script&lang=js"
import style0 from "./MiniGameList.vue?vue&type=style&index=0&id=f5676c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5676c30",
  null
  
)

export default component.exports